// extracted by mini-css-extract-plugin
module.exports = {"root":"Table__root","player_row":"Table__player_row","board":"Table__board"};